import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"items":_vm.options,"label":_vm.$t('Disable For Guest'),"item-text":"text","item-value":"value","outlined":"","hide-details":"auto"},model:{value:(_vm.disableForGuest),callback:function ($$v) {_vm.disableForGuest=$$v},expression:"disableForGuest"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }